import React from 'react';
import { getFestivalsAdmin, deleteFestival } from '../../../api/contentAdminApi';
import CmsAdminList from './CmsAdminList';

export default function FestivalsAdminList() {
	return (
		<CmsAdminList
			title="Festivals"
			description="Festival pages with dates, regions, and travel tips."
			addHref="/admin/cms/festival_form"
			formPath="/admin/cms/festival_form"
			resourceKey="festivals"
			fetchList={getFestivalsAdmin}
			deleteItem={deleteFestival}
			getRowTitle={(row) => row.name}
			getRowSubtitle={(row) => row.typical_month || row.date_type}
		/>
	);
}
